
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24.014"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M12.7.014c.46.061.927.115 1.388.19a11.253 11.253 0 012.363.677c-.169.433-.339.853-.515 1.293a10.5 10.5 0 00-9.35.745 10.071 10.071 0 00-4.61 5.639 10.6 10.6 0 1018.5-2.837c-.047.352-.095.677-.142 1.022-.467-.061-.921-.122-1.388-.176.135-1.083.271-2.139.413-3.216h3.209v1.381h-1.026c.068.1.1.162.149.223a11.8 11.8 0 012.268 6.154c.007.068.027.135.041.2v1.456l-.041.2c-.1.63-.156 1.273-.3 1.889a11.95 11.95 0 01-9.573 8.97c-.447.074-.894.122-1.34.183h-1.453l-.2-.041c-.63-.095-1.273-.156-1.889-.3a12.019 12.019 0 01-9.018-9.6c-.074-.44-.122-.88-.183-1.32v-1.5c.061-.447.108-.894.183-1.34a11.99 11.99 0 019.7-9.722c.454-.074.907-.129 1.368-.19.479.02.959.02 1.446.02z"}}),_c('path',{staticClass:"a",attrs:{"d":"M12.004 19.931a7.921 7.921 0 117.914-7.914 7.934 7.934 0 01-7.914 7.914zm3.243-8.693h-2.492V8.767h-1.5v3.988h3.994z"}})])
          )
        }
      }
    